/* src/components/settings/sections/KeyBindingsSettings.js */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKeyboard } from '@fortawesome/free-solid-svg-icons';
import {
    SectionCard,
    KeyBindingInput,
    LoadingSpinner
} from '../SettingSectionComponents';

const KeyBindingsSettings = ({
    localKeyBindings,
    settingKey,
    onStartSettingKey,
    isGeneralSectionDisabled,
    isSavingAppSettings,
    appSaveStatus,
    onSaveKeyBindings
}) => {
    return (
        <SectionCard title="Game Key Bindings" icon={faKeyboard}>
            <p className="text-sm text-gray-600 mb-4">
                Customize the keys used for matching during the game. Click a button, then press the desired key (Escape and Tab cannot be bound).
            </p>
            <div className="space-y-3">
                <KeyBindingInput
                    label="Position Match Key"
                    currentKey={localKeyBindings.visual}
                    isSetting={settingKey === 'visual'}
                    onStartSetting={() => onStartSettingKey('visual')}
                    disabled={isGeneralSectionDisabled}
                />
                <KeyBindingInput
                    label="Audio Match Key"
                    currentKey={localKeyBindings.audio}
                    isSetting={settingKey === 'audio'}
                    onStartSetting={() => onStartSettingKey('audio')}
                    disabled={isGeneralSectionDisabled}
                />
            </div>
            {/* Save Button Area for Key Bindings */}
            <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-end space-x-3">
                {appSaveStatus.section === 'keyBindings' && appSaveStatus.message && (
                    <span className={`text-sm font-medium ${appSaveStatus.type === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                        {appSaveStatus.message}
                    </span>
                )}
                <button
                    onClick={onSaveKeyBindings}
                    disabled={isGeneralSectionDisabled}
                    className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:opacity-50 transition-colors flex items-center justify-center min-w-[150px] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    {isSavingAppSettings && appSaveStatus.section === 'keyBindings' ? (
                        <><LoadingSpinner /> Saving...</>
                    ) : (
                        'Save Key Bindings'
                    )}
                </button>
            </div>
        </SectionCard>
    );
};

export default KeyBindingsSettings;